import { USER_ROLE } from '../../utils/constants';
import DietPlansList from './dietPlans';
import AddUpdateDietPlan from './dietPlans/addUpdateDietPlans';
import FoodItemsList from './foodItems';
import AddUpdateFoodItems from './foodItems/addUpdateFoodItems';
import RECIPE_LINKS from './links';
import MealPlansList from './mealPlans';
import AddUpdateMealPlans from './mealPlans/addUpdateMealPlans';
import RecipeList from './recipe';
import AddUpdateRecipe from './recipe/addUpdateRecipe';

const RECIPE_ROUTES = [
  {
    path: RECIPE_LINKS.RECIPE_LIST,
    exact: true,
    component: RecipeList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.RECIPE_ADD,
    exact: true,
    component: AddUpdateRecipe,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.RECIPE_EDIT,
    exact: true,
    component: AddUpdateRecipe,
    role: [USER_ROLE.ADMIN],
  },

  // Food Items
  {
    path: RECIPE_LINKS.FOOD_ITEMS_LIST,
    exact: true,
    component: FoodItemsList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.FOOD_ITEMS_ADD,
    exact: true,
    component: AddUpdateFoodItems,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.FOOD_ITEMS_EDIT,
    exact: true,
    component: AddUpdateFoodItems,
    role: [USER_ROLE.ADMIN],
  },

  // Food Items
  {
    path: RECIPE_LINKS.MEAL_PLAN_LIST,
    exact: true,
    component: MealPlansList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.MEAL_PLAN_ADD,
    exact: true,
    component: AddUpdateMealPlans,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.MEAL_PLAN_EDIT,
    exact: true,
    component: AddUpdateMealPlans,
    role: [USER_ROLE.ADMIN],
  },

  {
    path: RECIPE_LINKS.DIET_PLAN_LIST,
    exact: true,
    component: DietPlansList,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.DIET_PLAN_ADD,
    exact: true,
    component: AddUpdateDietPlan,
    role: [USER_ROLE.ADMIN],
  },
  {
    path: RECIPE_LINKS.DIET_PLAN_EDIT,
    exact: true,
    component: AddUpdateDietPlan,
    role: [USER_ROLE.ADMIN],
  },
];

export { RECIPE_LINKS, RECIPE_ROUTES };
